import { render, staticRenderFns } from "./AmarReports.vue?vue&type=template&id=f9937aba&scoped=true&"
import script from "./AmarReports.vue?vue&type=script&lang=js&"
export * from "./AmarReports.vue?vue&type=script&lang=js&"
import style0 from "./AmarReports.vue?vue&type=style&index=0&id=f9937aba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9937aba",
  null
  
)

export default component.exports